import { render, staticRenderFns } from "./hold-to-talk.vue?vue&type=template&id=61612bbe&scoped=true&"
import script from "./hold-to-talk.vue?vue&type=script&lang=js&"
export * from "./hold-to-talk.vue?vue&type=script&lang=js&"
import style0 from "./hold-to-talk.vue?vue&type=style&index=0&id=61612bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61612bbe",
  null
  
)

export default component.exports